import type { DragEvent } from 'react'

/**
 * Qué se está arrastrando ahora mismo en el constructor: un campo del lienzo (por su
 * posición) o un tipo nuevo de la paleta. Durante el arrastre el navegador no deja leer
 * los datos del `dataTransfer` (solo al soltar), y la línea que marca dónde caerá lo
 * necesita: se guarda aquí. Hay un constructor abierto a la vez.
 */
export type Arrastre = { que: 'campo'; indice: number } | { que: 'nuevo'; tipo: string }

let actual: Arrastre | null = null

export const empezarArrastre = (e: DragEvent, arrastre: Arrastre) => {
  actual = arrastre
  e.dataTransfer.effectAllowed = arrastre.que === 'campo' ? 'move' : 'copy'
  // Hace falta algún dato para que Firefox arranque el arrastre.
  e.dataTransfer.setData(
    'text/plain',
    arrastre.que === 'campo' ? `campo:${arrastre.indice}` : `nuevo:${arrastre.tipo}`,
  )
}

export const arrastreActual = (): Arrastre | null => actual

export const terminarArrastre = () => {
  actual = null
}
